(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-richtext"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', () => {
    const container = document.querySelector('.richtext-content-block');
    if (!container) return;
    const content = container.querySelector('.richtext-content');
    const btn = container.querySelector('.read-more-btn');

    if (!content || !btn) return
    const isOverflowing = content.scrollHeight > 118;
    btn.style.display = isOverflowing ? 'inline-block' : 'none';
    btn.addEventListener('click', () => {
        const expanded = container.classList.toggle('expanded');
        btn.textContent = expanded ? 'Read Less' : 'Read More';
    });
});

  } catch(e) { console.error(e); }
})();
})();
